window.Products.DeviceCase.Iphone7Plus = function() {
};
window.Products.DeviceCase.Iphone7Plus.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.Iphone7Plus.id = 57;
window.Products.DeviceCase.Iphone7Plus.slug = 'iphone7plus';